// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConstants } from '@app/utils';
import { HttpClient } from '@angular/common/http';
import { LMLoggerService } from '@app/services';

@Injectable()
export class LMRelatedActionsService {
  constructor(
    private httpClient: HttpClient,
    private lmLoggerService: LMLoggerService
  ) {}

  public getRelatedActionMenuItems(relationActionUrl: string): Observable<RelatedMenuItemResponse> {
    return new Observable<RelatedMenuItemResponse> (observer => {
      this.httpClient
        .get(relationActionUrl).pipe(
          catchError(error => {
            this.lmLoggerService.error(error);
            return throwError(error || 'Server error');
          }))
        .subscribe((res: any) => {
          this.lmLoggerService.log('Related DataViewSet retrieved');
          if (res?.actionSpec?.type === AppConstants.ACTION_TYPE_CREATE
          ||  res?.actionSpec?.type === AppConstants.ACTION_TYPE_SET
          ||  res?.actionSpec?.type === AppConstants.ACTION_TYPE_IMPORT) {
            const headerRelMenItem: RelatedMenuItem[] = [ {
              text: res.dataViewSet.header.representativeText,
              resourceId: res.dataViewSet.header.resourceId
            } ];
            observer.next({
              dataViewSet: res.dataViewSet,
              actionSpec: res.actionSpec,
              relatedMenuItems: headerRelMenItem
            });
            observer.complete();
          } else {
            let i = 0;
            const relMenuItems: RelatedMenuItem[] = [];
            const dataViewSet = res.dataViewSet;
            dataViewSet.data.forEach(dataView => {
              relMenuItems[ i++ ] = { text: dataView.representativeText, resourceId: dataView.resourceId };
            });
            observer.next({ dataViewSet: dataViewSet, actionSpec: res.actionSpec, relatedMenuItems: relMenuItems });
            observer.complete();
          }
        });
    });
  }
}
